import React from 'react';

const Privacy = () => {
  return (
    <main className="pt-20 min-h-screen bg-white">
      <section className="section-spacing">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <span className="caption mb-4 block">Legal</span>
            <h1 className="heading-display mb-8">Política de Privacidade</h1>
            
            <div className="prose max-w-none">
              <p className="body-large mb-8">
                A eLauria está comprometida com a proteção dos dados pessoais de seus clientes, 
                parceiros e visitantes, em conformidade com a Lei Geral de Proteção de Dados (LGPD).
              </p>

              <h2 className="heading-3 mt-10 mb-4">1. Coleta de Dados</h2>
              <p className="body-medium text-gray-600 mb-6">
                Coletamos dados pessoais quando você preenche formulários em nosso site, 
                como nome, e-mail, telefone e informações profissionais. Esses dados são 
                utilizados exclusivamente para as finalidades informadas no momento da coleta.
              </p>

              <h2 className="heading-3 mt-10 mb-4">2. Uso dos Dados</h2>
              <p className="body-medium text-gray-600 mb-4">
                Os dados coletados são utilizados para:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                <li>Responder suas solicitações e dúvidas</li>
                <li>Elaborar propostas comerciais</li>
                <li>Analisar candidaturas para vagas de emprego</li>
                <li>Enviar comunicações relevantes sobre nossos serviços</li>
              </ul>

              <h2 className="heading-3 mt-10 mb-4">3. Compartilhamento</h2>
              <p className="body-medium text-gray-600 mb-6">
                Não compartilhamos seus dados pessoais com terceiros, exceto quando 
                necessário para o cumprimento de obrigações legais ou mediante seu 
                consentimento expresso.
              </p>

              <h2 className="heading-3 mt-10 mb-4">4. Segurança</h2>
              <p className="body-medium text-gray-600 mb-6">
                Adotamos medidas técnicas e organizacionais adequadas para proteger 
                seus dados contra acessos não autorizados, perda ou alteração.
              </p>

              <h2 className="heading-3 mt-10 mb-4">5. Seus Direitos</h2>
              <p className="body-medium text-gray-600 mb-6">
                Você pode solicitar acesso, correção, exclusão ou portabilidade de seus 
                dados pessoais a qualquer momento, entrando em contato conosco pelo 
                e-mail enrique.lauria@elauria.com.br.
              </p>

              <h2 className="heading-3 mt-10 mb-4">6. Cookies</h2>
              <p className="body-medium text-gray-600 mb-6">
                Utilizamos cookies para melhorar sua experiência de navegação. 
                Você pode configurar seu navegador para recusar cookies, embora isso 
                possa afetar algumas funcionalidades do site.
              </p>

              <h2 className="heading-3 mt-10 mb-4">7. Atualizações</h2>
              <p className="body-medium text-gray-600 mb-6">
                Esta política pode ser atualizada periodicamente. Recomendamos que 
                você a revise regularmente.
              </p>

              <p className="text-gray-400 text-sm mt-10">
                Última atualização: Agosto de 2025
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Privacy;
